/* eslint-disable camelcase */
import sui_required from './sui_required';
import sui_custom from './sui_custom';
import sui_example from './sui_example';

export default {
  sui_required,
  sui_custom,
  sui_example,
}
